import { useTranslation } from 'react-i18next';
import { Drawer as DrawerPrimitive } from 'vaul';

import { XIcon } from '../../../assets/X';
import { InfoCircleIcon } from '../../../assets/InfoCircle';
import { DrawerContent, DrawerTitle } from '../../../components/ui/drawer';
import { cn } from '../../../lib/utils';

type LoyaltyInfoDrawerProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

/**
 * Условия программы E-coins — шторка поверх шторки с QR.
 *
 * Вложенная (NestedRoot), а не «закрыть QR и открыть эту», как история
 * баллов: пока QR-шторка открыта, живут код и его таймер (useLoyaltyQr(open)),
 * а закрытие перезапросило бы код. Затемнение у неё слабее обычного — поверх
 * затемнения QR-шторки 80% + 80% давали чёрный фон.
 */
export const LoyaltyInfoDrawer = ({ open, setOpen }: LoyaltyInfoDrawerProps) => {
  const { t } = useTranslation();

  return (
    <DrawerPrimitive.NestedRoot open={open} onOpenChange={setOpen}>
      <DrawerContent
        handleClassName="hidden"
        overlayClassName="bg-black/40"
        className="border-none bg-white"
      >
        <div className="flex flex-col">
          <div className="flex h-12 items-center justify-between px-4 pb-2 pt-4">
            <DrawerTitle className="text-display-md text-text-primary">
              {t('loyalty-info-title')}
            </DrawerTitle>
            <button
              type="button"
              aria-label={t('close')}
              onClick={() => setOpen(false)}
              className="flex h-6 w-6 items-center justify-center rounded-full bg-fill-background"
            >
              <XIcon className="h-2.5 w-2.5 text-text-icon-secondary" />
            </button>
          </div>

          <p className="px-4 pt-3 text-body-base-regular text-text-secondary">
            {t('loyalty-info-text')}
          </p>

          <div className="px-4 pb-8 pt-6">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="flex h-12 w-full items-center justify-center rounded-[32px] bg-fill-background px-5 font-inter text-[14px] font-semibold leading-5 text-text-primary"
            >
              {t('close')}
            </button>
          </div>
          <div className="pb-safe-bottom" />
        </div>
      </DrawerContent>
    </DrawerPrimitive.NestedRoot>
  );
};

/**
 * Кнопка «i» — одна на оба экрана QR: на динамическом справа в плашке
 * баланса, на статичном (баланса там нет) — в шапке рядом с «×».
 */
export const LoyaltyInfoButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-label={t('loyalty-info-title')}
      onClick={onClick}
      className={cn('h-6 w-6 shrink-0 text-[#0B0D0F]', className)}
    >
      {/* Круг-подложка уже в самой иконке — своего фона у кнопки нет. */}
      <InfoCircleIcon className="h-full w-full" />
    </button>
  );
};
